<script lang="ts" setup>
import type { State } from '@/store/store_types';
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore<State>();
const fleetData = computed(() => store.state.fleet);

const fleet_name = computed(() => fleetData.value?.name ?? 'Fleet Name');
const team_name = computed(() => 'Team Name');
const logo_url = computed(() => fleetData.value?.logoSrc ?? '');

</script>
<template>
  <v-card class="pa-5 bg-pwt_snow" >
    <v-img :src="logo_url" max-width="150" class="mb-4" />
    <v-card-title class="text-body-2 d-flex flex-column"> 
      <span> {{ fleet_name }} </span>
      <span> {{ team_name }} </span>
    </v-card-title>
  </v-card>
</template>
